// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1lP2x","colMaxWidth":"Table_colMaxWidth__1aF5u"};